<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import SkillDetail from '../../../../skills/components/SkillDetail.vue'
import { SkillID } from '../../../../skills/models/skill'

definePage({
    props: true,
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        childNavItems: [
            {
                label: 'Business',
                route: '/(app)/settings/business/',
            },
            {
                label: 'Buildings',
                route: '/(app)/settings/buildings/',
            },
            {
                label: 'Skills',
                route: '/(app)/settings/skills/',
            },
            {
                label: 'Groups',
                route: '/(app)/settings/groups/',
            },
            {
                label: 'Shift Reasons',
                route: '/(app)/settings/shift-reasons/',
            },
        ],
    }
})

const {
  id,
} = defineProps<{
    id: SkillID
}>()
</script>

<template>
  <SkillDetail
    :id="id"
  />
</template>